import ApiService from './api.service';

const ServicesService = token => {
    const api = ApiService.createApiInstance(token);

    return {
        create(data) {
            return api.post(`/Services`, data);
        },
        get(id) {
            return api.get(`/Services/${id}`);
        },
        getBySlug(slug) {
            return api.get(`/Services/slug/${slug}`);
        },
        adminGet(serviceId) {
            return api.get(`/Services/admin-edit/${serviceId}`);
        },
        getBySlugAndPin(slug, pin) {
            return api.get(`/Services/${slug}/${pin}`);
        },
        dumpRedisCache(serviceId) {
            return api.post(`/Services/dump-redis-cache/${serviceId}`);
        },
        getEmbedCode(serviceId) {
            return api.get(`/embedcodes/service/${serviceId}`);
        },
        betaFeaturesByService(slug) {
            return api.get(`/Services/beta/${slug}`);
        },
        getLastScheduledEventTime(slug) {
            return api.get(`/services/last-scheduled-event-time/${slug}`);
        },
    };
};

export default ServicesService;
